import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const START_SPOTS = 7;
const MIN_SPOTS = 3;
export function ScarcityBar() {
  const [spots, setSpots] = useState(START_SPOTS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpots(s => s > MIN_SPOTS ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100;
  return <div className="rounded-2xl bg-dangerSoft p-4 ring-1 ring-danger/20" data-id="element-273" data-mp="2g6mimibzjw30">
      <p className="flex items-center justify-center gap-1.5 text-center text-sm font-bold text-danger sm:text-base" data-id="element-274" data-mp="226lfsxc5uekw">
        <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-275" data-mp="2766gpdaw4x09" />
        Only {spots} spots left at the promotional price
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-danger/20" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-276" data-mp="cm78jqfabbw">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: '80%'
      }} animate={{
        width: `${filled}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-277" data-mp="2zl19sljoypab" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-ink/60" data-id="element-278" data-mp="2knr09hqlzth8">{Math.round(filled)}% of promotional spots claimed</p>
    </div>;
}